export const PROFILE_SKELETONS = [
	{ nameWidth: '58%', bioWidth: '82%' },
	{ nameWidth: '64%', bioWidth: '74%' },
	{ nameWidth: '52%', bioWidth: '88%' },
	{ nameWidth: '60%', bioWidth: '70%' },
	{ nameWidth: '56%', bioWidth: '78%' },
];
